import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 20,
  flexGrow: 1,

  [theme.down("lg")]: {
    width: "100%",
  },
}));

export const ShowMoreButtonBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  ...theme.paddings(15),
}));

export const ShowMoreButton = styled("button")(({ theme }) => ({
  ...theme.paddings(5, 10),
  width: 170,
  height: 42,
  color: theme.palette.white,
  backgroundColor: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  fontSize: 14,
  cursor: "pointer",
  transition: "all 0.3s ease-out",

  "&:hover": {
    backgroundColor: theme.palette.hoverButtonBg,
    border: `1px solid ${theme.palette.primary.dark}`,
  },
}));

// FE-14: шапка списка — маршрут со счётчиком слева, сортировка справа.
export const ResultsHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(4),
  paddingBottom: theme.spacing(4),

  [theme.down("sm")]: {
    flexDirection: "column",
    alignItems: "stretch",
    gap: theme.spacing(3),
  },
}));

export const ResultsSummary = styled("div")(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
  fontVariantNumeric: "tabular-nums",
  minWidth: 0,

  "& > b": {
    color: theme.palette.text.primary,
    fontWeight: 600,
  },

  "& .route": {
    // на узком экране маршрут уступает место счётчику
    [theme.down("xs")]: {
      display: "none",
    },
  },
}));
